import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields"]
  static fillDelay = 450
  static startDelay = 5400

  connect() {
    this.timers = []
    this.followFields = true
    this.stopFollowing = () => { this.followFields = false }
    window.addEventListener("wheel", this.stopFollowing, { passive: true })
    window.addEventListener("touchstart", this.stopFollowing, { passive: true })
    const fields = Array.from(this.fieldsTarget.querySelectorAll("input, textarea, select"))
      .filter((field) => !["hidden", "file", "submit"].includes(field.type) && field.value)
      .filter((field) => !field.matches("[data-price-calculator-target='totalPrice'], [data-price-calculator-target='priceWithVat']"))
      .filter((field) => field.getClientRects().length > 0)
    const values = fields.map((field) => field.value)

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    fields.forEach((field) => { field.value = "" })
    fields.forEach((field, index) => {
      this.timers.push(window.setTimeout(() => {
        field.value = values[index]
        field.classList.add("demo-tour__filled")
        this.revealField(field)
      }, this.constructor.startDelay + index * this.constructor.fillDelay))
    })
    this.timers.push(window.setTimeout(() => {
      this.fieldsTarget.querySelectorAll("[data-controller~='price-calculator']").forEach((element) => {
        this.application.getControllerForElementAndIdentifier(element, "price-calculator")?.updateFromSalesPrice()
      })
    }, this.constructor.startDelay + fields.length * this.constructor.fillDelay))
    this.timers.push(window.setTimeout(() => {
      if (this.followFields) window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" })
    }, this.constructor.startDelay + fields.length * this.constructor.fillDelay + 900))
  }

  disconnect() {
    this.timers?.forEach((timer) => window.clearTimeout(timer))
    window.removeEventListener("wheel", this.stopFollowing)
    window.removeEventListener("touchstart", this.stopFollowing)
  }

  revealField(field) {
    if (!this.followFields) return

    const rect = field.getBoundingClientRect()
    if (rect.bottom > window.innerHeight - 120 || rect.top < 80) {
      field.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
}
